import { ActivatedRouteSnapshot } from '@angular/router';
import { StringUtils } from './string.utils';

export class NavigationUtils {
  static routeNestedParamsUtils(routeSnapshot: ActivatedRouteSnapshot) {
    while (routeSnapshot.firstChild) {
      routeSnapshot = routeSnapshot.firstChild;
    }
    return routeSnapshot.data;
  }

  static clearQueryParams(url: string) {
    return StringUtils.truncate(url, '?');
  }
}
